import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CtSponsoredTag } from './sponsored-tag';

/**
 * Encart « En vedette dans votre secteur ».
 *
 * La bordure or récolte le distingue des cartes ordinaires. La mention
 * « Sponsorisé » n'apparaît que pour les emplacements payants (lot 13) ;
 * les créneaux gagnés par palier ou succès restent organiques.
 */
@Component({
  selector: 'ct-featured-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CtSponsoredTag],
  template: `
    <div class="head">
      <h2>En vedette dans votre secteur</h2>
      @if (sponsored()) {
        <ct-sponsored-tag />
      }
    </div>
    <ng-content />
  `,
  styles: `
    :host {
      display: block;
      background: var(--ct-kraft);
      border: 1.5px solid var(--ct-or-recolte);
      border-radius: var(--ct-radius-lg);
      padding: var(--ct-space-3);
      overflow: hidden;
    }

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--ct-space-2);
      margin-bottom: var(--ct-space-2);
    }

    h2 {
      font-size: var(--ct-size-md);
    }
  `,
})
export class CtFeaturedBanner {
  /** Créneau payant (lot 13) — les emplacements gagnés restent à `false`. */
  readonly sponsored = input(false);
}
